/**
 * NB Event Queue | Queue
 *
 * @copyright 2023 NB Communication Ltd
 *
 */

import { base64Decode, base64Encode, clearStorage, eq, getKey, getTimestamp, gtagEvent, isActive, getNow } from '../js/_func.js';

function nbEventQueue() {

	const unhide = key => document.getElementById(getKey(key)).hidden = '';
	const error = msg => {
		const key = 'error';
		document.getElementById(getKey(key)).innerText = msg;
		unhide(key);
	};

	let session = window.location.search.replace(/\?session=(.*?)$/, '$1');
	if (session) {
		// Set this session in storage
		localStorage.setItem(getKey('session'), session);
	} else {
		// Get the session from storage
		session = localStorage.getItem(getKey('session'));
	}

	if (session) {

		try {

			// Get the session data
			const data = JSON.parse(base64Decode(session));
			if (data) {

				if (data.reset) {
					localStorage.removeItem(getKey('out'));
					delete data.reset;
				}

				let now = getNow();

				// If the queue is open, or prequeue
				if (isActive(data, now)) {

					const check = ts => {

						now = getNow();

						const minutes = (key, value) => {
							value = Math.ceil(value / 1000 / 60);
							document.getElementById(getKey(`${key}-time`)).innerText = `${value} minute${value === 1 ? '' : 's'}`;
							unhide(key);
						};

						if (now < data.open) {

							// Prequeue
							minutes('prequeue', data.open - now);

						} else {

							// Queue is open
							minutes('wait', ts - now);
							document.getElementById(getKey('prequeue')).hidden = 'hidden';

							if (ts < now) {

								eq('pass', {
									id: data.id,
									ts: data.ts,
									q: ts
								}, result => {

									if (result.status === 200) {
										clearStorage(['session', 'out', 'wait']);
										window.location.href = `${data.event}?token=${base64Encode([
											result.response,
											base64Encode(ts)
										].join('.'))}`
									}
								});
							}
						}
					};

					const checkTimestamp = ts => {
						// Check immediately
						check(ts);
						// Check every second using a worker
						const intervalWorker = new Worker(new URL('interval.js', import.meta.url));
						intervalWorker.onmessage = () => check(ts);
					};

					const ts = getTimestamp('out');
					if (ts && ts > data.open && ts < data.close) {

						// The out timestamp is in the window, start checking
						checkTimestamp(ts);

					} else {

						if (ts) {
							// remove old timestamp if it exists
							localStorage.removeItem(getKey('out'));
						}

						// Get an out timestamp
						eq('place', {
							open: data.open,
							close: data.close,
						}, result => {
							if (result.status === 200) {
								const place = parseInt(result.response);
								localStorage.setItem(getKey('out'), base64Encode(place));
								gtagEvent({ wait: Math.ceil((place - now) / 1000) }); //todo wait time from open
								checkTimestamp(place);
							}
						});
					}

				} else {

					// Queue is closed
					unhide('closed');
				}
			}

		} catch(e) {

			localStorage.removeItem(getKey('session'));
			error(e);
		}

	} else {

		error(`Sorry, you have arrived here incorrectly.\nPlease return to the event and see if you come back the right way...`);
	}
}

document.addEventListener('DOMContentLoaded', nbEventQueue);
